import { Component, OnInit } from '@angular/core';
import { IGarbageCollectorStatistic } from '../../interfaces/garbage-collector-statistic.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GarbageCollectorStatisticDialogComponent } from '../garbage-collector-statistic-dialog/garbage-collector-statistic-dialog.component';
import { APIInstanceService } from '../../services/api-instance.service';
import { tap } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-garbage-collector-section',
    templateUrl: './garbage-collector-section.component.html',
    styleUrls: ['./garbage-collector-section.component.scss']
})
export class GarbageCollectorSectionComponent implements OnInit {
    isRunning: boolean = false;

    constructor(private readonly dialog: MatDialog, private readonly apiInstanceService: APIInstanceService) {}

    get canStart(): boolean {
        return !this.isRunning;
    }

    ngOnInit(): void {}

    triggerGarbageCollector() {
        return this.apiInstanceService.triggerGarbageCollector().pipe(tap(data => this.showPopup(data)));
    }

    showPopup(data: IGarbageCollectorStatistic) {
        if (!data) {
            return;
        }

        const gcStatisticDialogConfig = new MatDialogConfig();
        gcStatisticDialogConfig.data = data;

        this.dialog.open(GarbageCollectorStatisticDialogComponent, gcStatisticDialogConfig);
    }
}
